
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.594 4H25v10.406l-.281.313-11 11-.719.688-.719-.688-9-9L2.593 16l.688-.719 11-11zm.844 2l-10 10 7.563 7.563 10-10V6h-7.563zM26 7h3v11l-.281.313L17.5 29.407l-.719-.688-1.938-1.969 1.406-1.406 1.25 1.25 9.5-9.438V9h-1V7zm-6 1a1 1 0 110 2 1 1 0 010-2z"}})])
          )
        }
      }
    